export default __webpack_public_path__ + "static/media/chevron-down-12.0a496c37.svg";